import colors from "./colors";

export default {
	colors,
	primaryColor: colors.orange,
	defaultTextColor: colors.white,
	backgroundColor: colors.grey3,
	errorColor: colors.red,
};
